import React from 'react';
import { User, Rocket, Building2, Quote } from 'lucide-react';
export function UseCases() {
  const cases = [{
    icon: <User className="w-6 h-6 text-blue-600" data-id="element-367" />,
    title: 'Indie Developers',
    challenge: "I want to monetize my AI tool but don't want to spend 2 weeks on billing infrastructure.",
    solution: 'Login, create project, add keys. Start charging in 5 minutes.',
    quote: 'I built an AI writing tool over the weekend. TokenGates let me add paid API in 5 minutes. Already have 5 paying customers.'
  }, {
    icon: <Rocket className="w-6 h-6 text-blue-600" data-id="element-368" />,
    title: 'AI Startups',
    challenge: 'We need to offer API access but building billing infrastructure takes weeks.',
    solution: 'Create project, paste your API keys (auth, LLMs, billing). Get endpoint. Done.',
    quote: 'We use PropelAuth for auth and Polar for billing. TokenGates connected them in literally 5 minutes. Zero backend code.'
  }, {
    icon: <Building2 className="w-6 h-6 text-blue-600" data-id="element-369" />,
    title: 'B2B SaaS',
    challenge: "Every new AI feature = rebuilding the same billing code. It's killing velocity.",
    solution: 'One TokenGates account, unlimited projects. New feature = new project = 5 minutes.',
    quote: 'We have 3 AI features (chat, transcription, embeddings). Each is a separate TokenGates project. Total setup time: 15 minutes.'
  }];
  return <section className="py-24 bg-white" data-id="element-370">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-371">
        <div className="text-center mb-16" data-id="element-372">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-373">
            Perfect For
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-374">
          {cases.map((item, i) => <div key={i} className="flex flex-col h-full bg-gray-50 p-8 rounded-2xl border border-gray-100" data-id="element-375">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm" data-id="element-376">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-377">
                {item.title}
              </h3>
              <div className="space-y-4 flex-grow" data-id="element-378">
                <div data-id="element-379">
                  <span className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-380">
                    Challenge
                  </span>
                  <p className="text-gray-600 mt-1" data-id="element-381">{item.challenge}</p>
                </div>
                <div data-id="element-382">
                  <span className="text-xs font-bold text-blue-400 uppercase tracking-wider" data-id="element-383">
                    Solution
                  </span>
                  <p className="text-gray-900 font-medium mt-1" data-id="element-384">
                    {item.solution}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}